import React from 'react'
import Group from 'components/utils/Group'
import BodyText from 'LuxKit/Typography/BodyText'
import PriceRowPrice from './PriceRowPrice'
import PriceRowSale from './PriceRowSale'
import Pill from 'LuxKit/Pill'
import LineAngleRightIcon from 'LuxKit/Icons/line/LineAngleRightIcon'
import Label from 'LuxKit/Label'
import styled from 'styled-components'
import { rem } from 'polished'
import Divider from 'LuxKit/Divider'
import pluralize from 'lib/string/pluralize'

const MAX_DISPLAY_RATES = 2

const Container = styled(Group)`
  position: relative;
  width: 100%;
  padding-bottom: ${rem(12)};
  display: inline-block;
`

const ContentWrapper = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: ${rem(8)};
  position: relative;
  top: ${rem(12)};
  padding: ${rem(20)} ${rem(16)} ${rem(12)} ${rem(16)};
  border: 1px solid ${props => props.theme.palette.neutral.default.five};
`

const LabelWrapper = styled.div`
  position: absolute;
  top: 0;
`

const DetailsWrapper = styled(Group)`
  &:hover {
    background-color: ${props => props.theme.palette.neutral.default.seven};
  }
`

const RateWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: ${rem(20)};
`

interface Props {
  label: string
  rates: App.FeedOperations['getLiveMetaOffers']['responses']['200']['content']['application/json']['result']['pinned_offers'][number]['packages']
}

export default function SalesBlock({ label, rates }: Props) {
  return <Container direction="vertical" gap={12}>
    <ContentWrapper>
      {rates?.slice(0, MAX_DISPLAY_RATES).map((rate, index) => (
        <DetailsWrapper direction="vertical" gap={8} key={rate.name}>
          <RateWrapper>
            <BodyText variant="small" weight="bold" wrap="truncate">{rate.name}</BodyText>
            <Group direction="horizontal" gap={12} horizontalAlign="space-between">
              <Group direction="vertical">
                <PriceRowPrice price={rate.salePrice} size="S" />
                <PriceRowSale value={rate.price} />
              </Group>
              <Pill variant="success" kind="primary">Save {rate.discountPercentage}%</Pill>
              <LineAngleRightIcon />
            </Group>
          </RateWrapper>
          {index !== rates.length - 1 && <Divider kind="primary" direction="horizontal" />}
        </DetailsWrapper>
      ))}
      {rates?.length && rates.length > MAX_DISPLAY_RATES && (
        <BodyText variant="small" underline>+{rates?.length - MAX_DISPLAY_RATES} {pluralize({ singular: 'room', plural: 'rooms', count: rates?.length - MAX_DISPLAY_RATES }).text} more on sale!</BodyText>
      )}
    </ContentWrapper>
    <LabelWrapper>
      <Label kind="primary" variant="urgency">{label}</Label>
    </LabelWrapper>
  </Container>
}
